import { CustomerDocumentEntity } from '../entities/customer-document-entity';

export default class State {
  loaded = false;

  items: Array<CustomerDocumentEntity> = [];
}
